<ui-dialog
    *ngIf="paidPayrolls.length"
    formDialog
    #filterModal
    [form]="journalEntryReportFilterForm.form"
    size="small"
    [open]="displayJournalEntryReportFilterModal"
    header="reporting.payroll.filterResults"
    [primaryButtonLabel]="'save'"
    (primaryButtonPressed)="onFilter(journalEntryReportFilterForm.dates, journalEntryReportFilterForm)"
    [secondaryButtonLabel]="'cancel'"
    (secondaryButtonPressed)="hideOrDisplayJournalEntryReportFilterModal(false)"
    (closing)="hideOrDisplayJournalEntryReportFilterModal(false)"
>
    <p>{{ 'reporting.payroll.journalEntry.filterNote' | translate }}</p>
    <app-form-filter-payroll-report
        [schedule]="schedule"
        [report]="journalEntryReport"
        [reportStartAt]="startAt"
        [reportEndAt]="endAt"
        [isJournalEntryV2Report]="true"
        [journalEntryReportPayPeriodOptions]="journalEntryReportPayPeriodOptions"
        [allPeriodProperty]="'allJournalEntryReportPeriods'"
        (journalEntryReportPayPeriodOptionsYearEmitter)="fetchJournalEntryReportPayPeriodOptions($event)"
        #journalEntryReportFilterForm
    ></app-form-filter-payroll-report>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <div class="flex align-items-center">
        <app-header [title]="'Journal Entry Report'" [back]="true" [backRoute]="'/reporting/payroll'"> </app-header>
        <div class="flex align-items-center justify-end">
            <ui-button type="link" [routerLink]="['/reporting', 'payroll', 'journal-entry', 'settings']">
                {{ 'reporting.payroll.reportSettings' | translate }}
            </ui-button>
            <ui-button
                *ngIf="paidPayrolls.length"
                class="margin-left-1"
                (click)="hideOrDisplayJournalEntryReportFilterModal(true)"
                type="outline"
                >{{ 'filter' | translate }}</ui-button
            >
            <ui-button *ngIf="paidPayrolls.length" class="margin-left-1" type="primary" [matMenu]="exportMenu">
                {{ 'export' | translate }} <mat-icon svgIcon="chevronDown"></mat-icon>
            </ui-button>
            <mat-menu #exportMenu="matMenu">
                <button mat-menu-item (click)="onExport('pdf')">PDF</button>
                <button mat-menu-item (click)="onExport('xlxs')">Excel</button>
                <button mat-menu-item (click)="onExport('csv')">CSV</button>
            </mat-menu>
        </div>
    </div>
    <div
        *ngIf="
            paidPayrolls.length && journalEntryReport?.sheet?.rows.length && journalEntryReport?.additionalReportFields
        "
        class="margin-bottom-3"
    >
        <p>
            {{ 'reporting.payroll.payCycleEnding' | translate }}:
            <span *ngIf="journalEntryReport?.additionalReportFields?.payPeriodEndDate; else displayDash">{{
                journalEntryReport.additionalReportFields.payPeriodEndDate
            }}</span>
        </p>
        <p>
            {{ 'reporting.payroll.paySchedule' | translate }}:
            <span *ngIf="journalEntryReport?.additionalReportFields?.paySchedule; else displayDash">{{
                journalEntryReport.additionalReportFields.paySchedule | titlecase
            }}</span>
        </p>
        <p *ngIf="displayChequeDate">
            {{ 'reporting.payroll.chequeDate' | translate }}:
            <span *ngIf="journalEntryReport?.additionalReportFields?.chequeDate; else displayDash">{{
                journalEntryReport.additionalReportFields.chequeDate
            }}</span>
        </p>
        <p>
            {{ 'reporting.payroll.lastExported' | translate }}:
            <span *ngIf="journalEntryReport?.additionalReportFields?.lastExportedAt; else displayDash">{{
                journalEntryReport.additionalReportFields.lastExportedAt
            }}</span>
        </p>
    </div>
    <ui-card>
        <div
            *ngIf="paidPayrolls.length && journalEntryReport?.sheet?.rows.length; else displayNoJERReports"
            class="table-wrap"
        >
            <table class="ui table">
                <thead>
                    <tr>
                        <th *ngFor="let columnHeader of journalEntryReport.sheet.columns">
                            <span class="column-title"> {{ columnHeader.title }} </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of journalEntryReport.sheet.rows">
                        <td *ngFor="let cell of row.cells">
                            <span *ngIf="cell.value; else displayDash"> {{ cell.value }} </span>
                            <ng-template #displayDash>
                                <span>-</span>
                            </ng-template>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>{{ 'reporting.payroll.total' | translate }}</td>
                        <td></td>
                        <td></td>
                        <td *ngIf="journalEntryReport?.additionalReportFields?.totalDebit; else displayDash">
                            {{ journalEntryReport.additionalReportFields.totalDebit }}
                        </td>
                        <td *ngIf="journalEntryReport?.additionalReportFields?.totalCredit; else displayDash">
                            {{ journalEntryReport.additionalReportFields.totalCredit }}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <ng-template #displayNoJERReports>
            <app-empty-state
                label="reporting.payroll.noRecordsForDateRange"
                src="/assets/illustrations/documents.png"
            ></app-empty-state>
        </ng-template>
    </ui-card>
</div>

<ng-template #displayDash>
    <span>-</span>
</ng-template>
